import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface ILifeMilestonePayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  title_prefix?: string;
  title_highlight?: string;
  title_suffix?: string;
  title_highlight_color?: string;
  background_color?: string;
  image_frame_color?: string;
  hero_image?: string;
  hero_image_mobile?: string;
  hero_image_alt?: string;
  timeline_color?: string;
  auto_rotate_seconds?: number;
  metadata?: unknown[];
  status?: boolean;
  block_main_title?: string;
  block_subtitle?: string;
  block_body?: string;
  block_cta_label?: string;
  block_cta_url?: string;
  is_cta?: boolean;
  block_feature_label?: string;
}

export async function createLifeMilestone(payload: Partial<ILifeMilestonePayload>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.LIFE_MILESTONE.CREATE,
      payload,
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateLifeMilestone(
  id: number,
  payload: Partial<ILifeMilestonePayload>,
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.LIFE_MILESTONE.UPDATE(id),
      payload,
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
